import format from "date-fns/format";
import { store } from "store/store";
import * as wjcCore from "@grapecity/wijmo";

export const wijmoHideColumns = (flex, columnNames) => {
  flex.columns.forEach((c) => {
    if (columnNames.includes(c.binding)) c.visible = false;
  });
};

export const wijmoAggregateColumns = (flex, columnNames, aggFunction) => {
  flex.columns.forEach((c) => {
    if (columnNames.includes(c.binding)) c.aggregate = aggFunction;
  });
};

export const wijmoMergeColumns = (flex, columnNames) => {
  flex.columns.forEach((c) => {
    if (columnNames.includes(c.binding)) c.allowMerging = true;
  });
};

export const wijmoDateFormat = (
  panel,
  r,
  c,
  cell,
  dateColumn,
  time = false,
  dateFormat
) => {
  if (
    panel.columns[c]?.binding === dateColumn &&
    panel.cellType === 1 &&
    cell.innerHTML !== ""
  ) {
    const date = new Date(cell.innerHTML);
    if (time) cell.innerHTML = format(date, `${dateFormat?.format} HH:mm`);
    else {
      cell.innerHTML = format(date, `${dateFormat?.format}`);
    }
  }
};

export const wijmoCurrencyFormat = (panel, r, c, cell, currencyColumns) => {
  const currDecimals = 2;
  const currDecimalSep = ",";

  if (
    currencyColumns.includes(panel.columns[c]?.binding) &&
    panel.cellType === 1 &&
    cell.innerHTML !== ""
  ) {
    const commasRemoved = cell.innerHTML.replace(/\,/g, "");
    const value = parseFloat(commasRemoved).toFixed(currDecimals);
    const formatValue = parseFloat(value);
    const formatter = new Intl.NumberFormat(
      currDecimalSep === "," ? "el-GR" : "el-GR",
      {
        minimumFractionDigits: currDecimals,
        maximumFractionDigits: currDecimals,
      }
    );
    cell.innerHTML = formatter.format(formatValue);
  }
};
